import './media-gallery.css';

import { ListingPhoto } from './listing-photo';
import { IListingPhoto } from '../../models/listing-photo.model';
import { iconCamera } from '../../util/icons';

export interface MediaGalleryProps {
  photos: IListingPhoto[];
  openGallery(slide: number): void;
}

export const MediaGallery = (props: MediaGalleryProps) => {

  if (props.photos.length === 0) {
    return <div className="media-gallery"><div className="no-photos">No Photos Currently Available</div></div>
  }

  return (
    <div className="media-gallery">
      {props.photos.map((photo, i) =>
        <div onClick={() => props.openGallery(i)} style={{ cursor: 'pointer' }} key={i} className={i === 0 ? 'primary-listing-photo' : 'secondary-listing-photo'}>
          <ListingPhoto id={photo.id} description={photo.description} description2={photo.description2} url={photo.url} />
          {props.photos.length !== 0 && i === 0 &&
            <div className="media-gallery-total"><div className="media-gallery-total-space"></div><div onClick={() => props.openGallery(0)} className="media-gallery-total-icon">{iconCamera} {props.photos.length}</div></div>
          }
        </div>
      )}
    </div>
  );
}
